module.exports = __webpack_public_path__ + "img/travel.2ce33b15.png";